const ITEMS = [
  "FORGE YOUR LEGACY",
  "CONQUER THE REALM",
  "DEFEND THE CROWN",
  "RAISE THE BANNERS",
  "RULE THE KINGDOM",
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="marquee"
      className="relative overflow-hidden border-y border-white/10 bg-[#0b0b0b] py-8"
    >
      <div className="marquee-track flex w-max items-center gap-12 whitespace-nowrap">
        {[...row, ...row].map((item, i) => (
          <span key={i} className="flex items-center gap-12">
            <span className="font-display text-4xl font-semibold tracking-tight text-[#EAEAEA]/90 md:text-6xl">
              {item}
            </span>
            <span className="font-accent text-2xl text-[#D4AF37]">&#10022;</span>
          </span>
        ))}
      </div>
    </div>
  );
};
